import { render } from "./UserProfilePersonal.vue?vue&type=template&id=1ce2879b&ts=true"
import script from "./UserProfilePersonal.vue?vue&type=script&lang=ts"
export * from "./UserProfilePersonal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__